<app-modal>
  <h2 class="mb-0100">New {{toEntityType?.nameSingular | propercase}} Connection</h2>
  <div>
    <ng-container *ngIf="!createdConnection">
      <mat-form-field class="col__"
                      [appHide]="this.data.entityConnectionType">
        <mat-label>Choose an entity type to connect to...</mat-label>
        <mat-select placeholder="Entity Type"
                    name="entityType"
                    class="capitalize"
                    [formControl]="entityConnectionTypeInput"
                    [disableRipple]="true"
                    [compareWith]="compareByIdFn">
          <mat-option *ngFor="let ect of entityConnectionOptions"
                      [value]="ect"
                      class="capitalize">
            {{getOppositeEntityType(ect)?.nameSingular}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <app-entity-autocomplete *ngIf="toEntityType && !selectedEntity"
                               [labelText]="'Search for a ' + toEntityType.nameSingular"
                               [allowCreateNew]="true"
                               [excludeEntitiesFn]="excludeEntitiesFn(data.fromEntityId)"
                               [entityTypeIds]="[toEntityType.id]"
                               [campaignId]="data.campaignId"
                               (entitySelected)="entitySelected($event)">
      </app-entity-autocomplete>

      <div class="results__entity flex flexJustify--between flexAlign--center"
           *ngIf="selectedEntity">
        <app-entity-avatar [assessmentLevel]="selectedEntity.currentAssessmentLevel"
                           [entityTypeId]="selectedEntity.entityTypeId"
                           [spotlightIcon]="selectedEntity.spotlightIcon"
                           size="sm">
        </app-entity-avatar>
        <div class="results__main pr-0200">
          <app-entity-name [entity]="selectedEntity"></app-entity-name>
          <span class="results__location"
                *ngIf="selectedEntity.bestAddress">{{selectedEntity?.bestAddress | cityState}}</span>

          <div class="results__clear">
            <button class="link color--red"
                    (click)="selectedEntity = null">
              <i class="fal fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>

      <mat-form-field class="col__">
        <mat-label>Note</mat-label>
        <textarea matInput
                  [formControl]="noteInput"></textarea>
      </mat-form-field>

      <button type="button"
              [disabled]="saveDisabled"
              (click)="onSubmitClick()"
              class="btn ml-auto">Save Connection</button>
    </ng-container>

    <!-- Displayed after connection is created-->
    <div class="mb-0100"
         *ngIf="createdConnection">
      <app-entity-connection-row class="entity-connection-group-table table d-block mb-0100"
                                 [notesExpanded]="true"
                                 [infoExpanded]="true"
                                 [entityConnectionTypeId]="createdConnection.entityConnectionTypeId"
                                 [entityConnection]="createdConnection"
                                 [campaignId]="createdConnection.campaignId"
                                 [entityId]="data.fromEntityId">

      </app-entity-connection-row>

      <button type="button"
              (click)="close()"
              class="btn ml-auto">Close</button>
    </div>


  </div>
</app-modal>
